import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery } from '@coolblue-development/freddy';
import { freddyTheme as theme } from '@coolblue-development/freddy/theme/config';
import showBannerTrigger from '@coolblue-development/ga4-events/triggers/Banners/showBannerTrigger';
import { TrackImmediate } from '@coolblue-development/next-analytics/client';
export const TrackWhenAdShown = ({ hideOnMobile, hideOnDesktop, trackingParams, }) => {
    const isMediumBreakpointOrUp = useMediaQuery(theme.breakpoint.minWidth('md'));
    return (((isMediumBreakpointOrUp === true && !hideOnDesktop) ||
        (isMediumBreakpointOrUp === false && !hideOnMobile)) && (_jsx(TrackImmediate, { trigger: showBannerTrigger(trackingParams) })));
};
//# sourceMappingURL=TrackWhenAdShown.js.map